import { render, staticRenderFns } from "./group-buy.vue?vue&type=template&id=61dd6eb8&scoped=true&"
import script from "./group-buy.vue?vue&type=script&lang=js&"
export * from "./group-buy.vue?vue&type=script&lang=js&"
import style0 from "./group-buy.vue?vue&type=style&index=0&id=61dd6eb8&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "61dd6eb8",
  null
  
)

export default component.exports